import React from 'react';
import classnames from 'classnames';
import { get } from 'lodash';
import { translate } from 'react-i18next';
import i18next from 'i18next';

import { moneyFormat } from 'Parts/common/moneyFormat';
import LinkButton from 'Parts/common/LinkButton';

import PublicEventThermometer_en from './locales/PublicEventThermometer_en.json';
import PublicEventThermometer_fr from './locales/PublicEventThermometer_fr.json';

import './PublicEventThermometer.less';

class PublicEventThermometer extends React.Component {
    constructor(props) {
        super(props);

        props.fetchEvent(props.entity.id, false, { showLocation: true, showSettings: true });

        this.state = {
            progressPercent: this.getPercent(props.campaign),
            //TODO: Remove this temporary hardcoded campaign functionality
            hideDonation: props.campaign.id === 354 && props.platform.id === 77
        };

        this.height = 40;

        if (typeof window !== 'undefined') window.addEventListener('resize', this.handleResize);

        i18next.addResourceBundle('en', 'PublicEventThermometer', PublicEventThermometer_en);
        i18next.addResourceBundle('fr', 'PublicEventThermometer', PublicEventThermometer_fr);
    }

    componentDidMount() {
        if (typeof window !== 'undefined') this.handleResize();
    }

    componentDidUpdate() {
        if (typeof window !== 'undefined') this.handleResize();
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const element = typeof window !== 'undefined' && document.getElementById("PublicEventThermometer__Bar");
        const width = element && element.offsetWidth || null;
        let percent = this.getPercent(this.props.campaign, width);

        if (percent !== this.state.progressPercent) {
            this.setState({
                progressPercent: percent
            });
        }
    };

    getPercent = (campaign, width = null) => {
        const collected = Number(get(campaign, 'collected', 0).toString().replace('NaN', 0)) * get(campaign, 'settings.thermometer.multiplier', 1);
        let percent = (collected >= 0 && get(campaign, 'goal') > 0) &&
            collected / campaign.goal || 0;
            //percent= .5;// only for testing
        //if (width && width * percent < this.height) {
        //    percent = this.height + "px";
        //} else {
            percent = percent > 1 ? '100%' : (percent * 100) + "%";
        //}
        return percent;
    };

    render() {
        const { props, state, height } = this,
        { t, locale, className, campaign, giveUrl, donationClosed } = props,
        { progressPercent, hideDonation } = state;

        const computedClassName = classnames(
            'PublicEventThermometer',
            className
        );

        const collected = Number(get(campaign, 'collected', 0).toString().replace('NaN', 0)) * get(campaign, 'settings.thermometer.multiplier', 1);

        const formatedGoal = get(campaign, 'goal') >= 0 && moneyFormat(campaign.goal, locale) || moneyFormat(0, locale);
        const formatedCollected = collected >= 0 && moneyFormat(collected, locale) || moneyFormat(0, locale);
        const percent = parseInt((collected >= 0 && get(campaign, 'goal') > 0) && collected / campaign.goal * 100 || 0);

        const donationButton = this.props.isBillingConfigured && giveUrl && !donationClosed && !hideDonation
            ?   (
                    <LinkButton to={giveUrl} type="primary" className="PublicThermometer__DonateBtn">
                        {t('donate')}
                    </LinkButton>
                )
            : null;

        return (
            <div className={computedClassName}>
                    <div className="PublicEventThermometer__Info">
                        <span><label>{t('goal')}</label> {formatedGoal}</span>
                        <span><label>{t('raised')}</label> {formatedCollected}</span>
                        {donationButton}
                    </div>
                    <div
                        id="PublicEventThermometer__Bar"
                        className="PublicEventThermometer__Bar"
                        style={{
                            height: height + "px",
                        }}>
                        <div
                            className="PublicEventThermometer__Progress"
                            style={{
                                width: progressPercent,
                                height: height + "px",
                            }}
                        >
                            <span className={`PublicEventThermometer__Percent ${percent >= 50 ? "inside" : "inside"}`}>{percent}%</span>
                        </div>
                    </div>
            </div>
        );
    }
}

PublicEventThermometer.defaultProps = {};

PublicEventThermometer.propTypes = {};

export default translate('PublicEventThermometer')(PublicEventThermometer);
